import { defineStore } from "pinia";
import { hasRole, TIER_PRICING_CONTRIBUTOR_ROLE } from "@/auth";

interface State {
  userName: string;
  userEmail: string;
}

export const useGlobalStore = defineStore("global", {
  state: (): State => ({
    userName: "",
    userEmail: ""
  }),
  getters: {
    canEdit: () => hasRole(TIER_PRICING_CONTRIBUTOR_ROLE)
  }
});
